'use client'

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import { AuthContext } from "@/context/authContext";
import customAlert from "@/util/customAlert";
import api from "@/util/api";
import { useTranslations } from "next-intl";


export default function FloatMyinfoChange() {
    const { myinfoShow, SetMyinfoShow, SetPasswordShow, handlePasswordChangeSubmit } = useContext(SignContext)

    const [id, setId] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [password2, setPassword2] = useState<string>("")

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    const formRef = useRef<HTMLFormElement>(null)
    const idInputRef = useRef<HTMLInputElement>(null)

    const { user, loading, userUpdate } = useContext(AuthContext)

    const [nickname, setNickname] = useState<string>()
    const [phoneNumber, setPhoneNumber] = useState<string>(user.is_authenticated && user.phone_number || "")

    function changePhoneNumber() {
        if (phoneNumber && user.is_authenticated) {
            const phoneRegex = /^01[016789]\d{7,8}$/;
            if (!phoneRegex.test(phoneNumber)) {
                customAlert(a("InvalidPhoneNumber"), 'warning');
                return;
            }
            const formData = new FormData();
            formData.set('username', user.id)
            formData.set('phone_number', phoneNumber)

            api(`/api/user/edit/phone_number/`, { method: 'post', body: formData, })
                .then(res => res.json())
                .then(({ status, message }) => {
                    customAlert(message, status)
                    if (status == 'success') {
                        userUpdate({ phone_number: phoneNumber })
                    }

                })
        } else {
            customAlert(a('EnterPhoneToUpdate'), 'warning')
        }
    }

    function handleDuplicateNickname() {
        if (nickname && user.is_authenticated) {
            if (nickname == user.nickname) {
                customAlert(a("NicknameAlreadyUsed"), 'warning')
                return;
            }
            const formData = new FormData();
            formData.set('nickname', nickname)
            api(`/api/user/register/duplicate/`, { method: 'post', body: formData, })
                .then(res => res.json())
                .then(({ status }) => {
                    if (status == 'success') {
                        handleChangeNickname(nickname, user.id);
                    } else {
                        customAlert(a('NicknameAlreadyUsed'), 'warning')
                    }
                })
        } else {
            customAlert(a('EnterNewNickname'), 'warning')
        }
    }

    function handleChangeNickname(nickname: string, user_id: string) {
        const formData = new FormData();
        formData.set('nickname', nickname)
        formData.set('username', user_id)
        api(`/api/user/edit/nickname/`, { method: 'post', body: formData, })
            .then(res => res.json())
            .then((data) => {
                customAlert(data.message, data.status)
                if (data.status == 'success') {
                    userUpdate({ nickname: nickname })
                }
            })
    }

    const codeRef = useRef<HTMLInputElement>(null)
    function setCode(){
        if(user.is_authenticated && user.code){
            customAlert(a('referrerLocked'), 'warning')
            return;
        }
        if(codeRef.current){
            const ref = codeRef.current
            if(ref.value && user.is_authenticated){

                if(ref.value.length > 10){
                    customAlert(a('referralCodeTooLong'), 'warning')
                    return;
                }
                // 추천인 등록 (없을 때만)
                const formData = new FormData()
                formData.set('username', user.id)
                formData.set('code', ref.value)

                api(`/api/user/edit/joincode/`, { method: "POST", body: formData })
                    .then(res=> res.json())
                    .then(({status_code, status, message})=> {
                        if(status_code == 200){
                            userUpdate({ code: ref.value })
                        }
                        customAlert(message, status)
                    })
                    .catch((error: Response)=> {
                        customAlert(`${a("ErrorRequest")} (${error.status})`, 'error')
                        console.error(error)
                    })
            }else{
                customAlert(a("EnterReferralCode"), 'warning')
            }
        }
    }


    useEffect(() => {
        if (user.is_authenticated) {
            setPhoneNumber(user.phone_number)
            setNickname(user.nickname)
        }
    }, [user])

    if (!user.is_authenticated) return null;
    return (
        <FloatDialog
            show={myinfoShow}
            setShow={SetMyinfoShow}
            className="password-change"
        >
            <FloatDialog.Head>{t("내정보 변경")}</FloatDialog.Head>
            <FloatDialog.Body>
                <div className="password-container">
                    <div className="form-body">
                        <div className={`flex center`}>
                            <label className={`m-r-8 font-13 w-15-per`}>{t("닉네임")}</label>
                            <input type="text"
                                name="nickname"
                                placeholder={t("닉네임")}
                                defaultValue={nickname}
                                onChange={e => setNickname(e.currentTarget.value)}
                                className={`m-r-8 w-70-per`} />
                            <button className={`w-15-per`} onClick={handleDuplicateNickname}>{t("변경")}</button>
                        </div>
                        <div className={`flex center`}>
                            <label className={`m-r-8 font-13 w-15-per`}>{t("연락처")}</label>
                            <input type="text"
                                name="phone_number"
                                placeholder={a("NoHyphens")}
                                defaultValue={phoneNumber}
                                onChange={(e) => { setPhoneNumber(e.currentTarget.value); }}
                                maxLength={11}
                                className="m-r-8 w-70-per" />
                            <button className={`w-15-per`} onClick={changePhoneNumber}>{t("변경")}</button>
                        </div>
                        <div className={`flex center`}>
                            <label className={`m-r-8 font-13 w-15-per`}>{t("추천인")}</label>
                            <input type="text"
                                name="code"
                                ref={codeRef}
                                defaultValue={user.code}
                                readOnly={user.code ? true : false}
                                maxLength={10}
                                className="m-r-8 w-70-per" />
                            <button className={`w-15-per ${user.code && "disabled"}`} onClick={setCode}>{t("등록")}</button>
                        </div>

                    </div>
                    {/* <div className="btns">
                            <button type="submit">내정보 변경</button>
                            <button type="button" onClick={e=> SetMyinfoShow(false)}>닫기</button>
                        </div> */}
                </div>
                <form ref={formRef} onSubmit={e => handlePasswordChangeSubmit(e, id, password, password2, () => { setId(""); setPassword(""); setPassword2(""); SetMyinfoShow(false) })}>
                    <h5 className="p-l-10">{t("비밀번호 변경")}</h5>
                    <div className="password-container">

                        <div className="form-body">
                            <input type="text"
                                name="username"
                                placeholder={t("아이디 또는 이메일")}
                                onChange={e => setId(e.currentTarget.value)}
                                autoFocus
                            />
                            <input type="password"
                                name="password"
                                placeholder={t("변경 비밀번호")}
                                onChange={e => setPassword(e.currentTarget.value)}
                            />
                            <input type="password"
                                name="password2"
                                placeholder={t("비밀번호 확인")}
                                onChange={e => setPassword2(e.currentTarget.value)}
                            />

                        </div>
                        <div className="btns">
                            <button type="submit">{t("비밀번호 변경")}</button>
                            <button type="button" onClick={e => SetMyinfoShow(false)}>{t("닫기")}</button>
                        </div>
                    </div>
                </form>
            </FloatDialog.Body>
        </FloatDialog>
    )
}